import { default as DOMPurify, type DOMPurify as DOMPurifyType } from 'dompurify';

/**
 * Applies common configuration to a DOMPurify instance
 * so we get consistent results on the browser and server
 */
export const configure = (domPurifyInstance: DOMPurifyType): void => {
  if (typeof domPurifyInstance.addHook !== 'function') {
    return; // Skip configuration in test environment since DOMPurify depends on the browser
  }

  domPurifyInstance.addHook('afterSanitizeAttributes', (node: Element) => {
    if (node.tagName === 'A') {
      node.setAttribute('target', '_blank');

      // Extra sanitation
      // https://developer.chrome.com/docs/lighthouse/best-practices/external-anchors-use-rel-noopener
      node.setAttribute('rel', 'noopener noreferrer');
    }
  });
};

/**
 * Creates and configures a DOMPurify instance for use in the web browser
 *
 * We should always sanitize fields that contain markup when rendering
 * with dangerouslySetInnerHTML in the browser even if the server
 * endpoint sanitizes on save as an extra precaution against future bugs
 */
export const createBrowserDOMPurify = (): DOMPurifyType => {
  const domPurifyInstance = DOMPurify;
  configure(domPurifyInstance);
  return domPurifyInstance;
};

export const BrowserDOMPurify = createBrowserDOMPurify();
